var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"text-center"},[_c('div',{staticClass:"hero"},[_c('h3',{staticClass:"display-3"},[_vm._v(" Unsupported Browser ")]),_vm._v(" Your browser is not supported. Please use the latest version of Chrome, Firefox, or Safari to continue. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }